import React, { useState, useRef, useMemo, useEffect } from 'react'
import { Model } from 'survey-core'
import { Survey } from 'survey-react-ui'
// import 'survey-core/defaultV2.min.css'

import { useConvertSurvey } from '../hooks/useConvertSurvey'
import { useSubmitAnswers } from '../hooks/useSubmitAnswers'
import 'survey-core/i18n/traditional-chinese'
import { useSurveyParams } from '../context/SurveyParamsContext'
import { useProgressSaving } from '../hooks/useProgressSaving'

const Agree = ({
  setAc,
  setTk,
  ac,
  tk,
  pid,
  setIsLoading,
  setCompletionMessage,
}) => {
  const { userId, sfdSamplerId, sfdPId } = useSurveyParams()
  const [myAgreeJson, setMyAgreeJson] = useState(null)
  const userIdRef = useRef(null)
  useEffect(() => {
    if (userId) userIdRef.current = userId
  }, [userId])
  // 需要登入嗎
  const requiresLogin = {
    login: userId ? true : false,
    title: '員工編號（邁達特：MA、啟迪：GI、聚上雲：EP、逐鹿：GU）',
    placeholder: 'MA00000',
    alert: '員工編號有誤，請重新登入，謝謝',
    // useUserIdLogin: true,
  }
  const [imagesReadingTime, setImagesReadingTime] = useState(0)
  const canShowPrevButtonPages = [
    0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
    21, 22, 23, 24, 25, 26, 27, 28, 29, 30,
  ]
  const choicesOrderRef = useRef({})
  const choiceIndexMapRef = useRef({})
  const bringOptionsMapRef = useRef({})
  // 防止閃閃
  useEffect(() => {
    const timeout = setTimeout(() => {
      const isMobile = window.innerWidth <= 576
      if (!isMobile) return

      const observer = new MutationObserver((mutationsList) => {
        for (let mutation of mutationsList) {
          if (mutation.type === 'childList') {
            const rootEl = document.querySelector('.sd-root-modern')
            if (
              rootEl &&
              !rootEl.classList.contains('sd-root-modern--mobile')
            ) {
              rootEl.classList.add('sd-root-modern--mobile')
              console.log('✅ 強制加上 mobile class 避免抖動')
            }
          }
        }
      })

      observer.observe(document.getElementById('root'), {
        childList: true,
        subtree: true,
      })

      // 清除
      return () => observer.disconnect()
    }, 100) // 100ms 後再判斷

    return () => clearTimeout(timeout)
  }, [])
  // 圖片閱讀時間(秒)
  // useEffect(() => {
  //   setImagesReadingTime(30)
  // }, [])
  const completedHtml = `<h3>問卷正在提交中，請稍候。</h3><h3>請在成功頁面顯示後再離開。</h3><h4>如有填卷相關問題請洽：</h4> <a href='https://lin.ee/HWETcqy'>https://lin.ee/HWETcqy</a><h4 style='margin-top:50px'>填寫其他問卷：</h4> <a href=${window.location.origin}>${window.location.origin}</a>`

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const agreeSurvey = new Model(myAgreeJson)

  // 問卷編號
  // const pid = pid
  // 跳題 小心複選題要用陣列

  // const visibleIfConditionsInit = {
  //   q6: '{q5} = 0 or {q5} = 1 or {q5} = 2 or {q5} = 3',
  //   q7: '{q6} = ["none"]',
  //   q36: `{q35} <> ['none']`,
  // }

  const visibleIfConditionsInitBase = {
    q7: '{q6} = 1',
    q8: '{q6} = 1',
    q9: '{q6} = 1',
    q10: '{q6} = 2',

    q13: '{q12} anyof [0]',
    q14: '{q12} anyof [1]',
    q15: '{q12} anyof [2]',
    q16: '{q12} anyof ["other"]',

    // 特殊矩陣
    q18: '{q17.0} = 1 or {q17.1} = 1 or {q17.2} = 1 or {q17.3} = 1 or {q17.4} = 1 or {q17.5} = 1 or {q17.6} = 1 or {q17.7} = 1 or {q17.8} = 1 or {q17.9} = 1',
    'q18.row0': '{q17.0} = 1',
    'q18.row1': '{q17.1} = 1',
    'q18.row2': '{q17.2} = 1',
    'q18.row3': '{q17.3} = 1',
    'q18.row4': '{q17.4} = 1',
    'q18.row5': '{q17.5} = 1',
    'q18.row6': '{q17.6} = 1',
    'q18.row7': '{q17.7} = 1',
    'q18.row8': '{q17.8} = 1',
    'q18.row9': '{q17.9} = 1',
    q19: '{q18.0} = 0',
    q20: '{q18.1} = 0',
    q21: '{q18.2} = 0',
    q22: '{q18.3} = 0',
    q23: '{q18.4} = 0',
    q24: '{q18.5} = 0',
    q25: '{q18.6} = 0',
    q26: '{q18.7} = 0',
    q27: '{q18.8} = 0',
    q28: '{q18.9} = 0',

    q29: '({q17.0} = 1 or {q17.1} = 1 or {q17.2} = 1 or {q17.3} = 1 or {q17.4} = 1 or {q17.5} = 1 or {q17.6} = 1 or {q17.7} = 1 or {q17.8} = 1 or {q17.9} = 1) and ({q18.0} = 1 or {q18.1} = 1 or {q18.2} = 1 or {q18.3} = 1 or {q18.4} = 1 or {q18.5} = 1 or {q18.6} = 1 or {q18.7} = 1 or {q18.8} = 1 or {q18.9} = 1)',
    'q29.row0': '{q17.0} = 1 and {q18.0} = 1',
    'q29.row1': '{q17.1} = 1 and {q18.1} = 1',
    'q29.row2': '{q17.2} = 1 and {q18.2} = 1',
    'q29.row3': '{q17.3} = 1 and {q18.3} = 1',
    'q29.row4': '{q17.4} = 1 and {q18.4} = 1',
    'q29.row5': '{q17.5} = 1 and {q18.5} = 1',
    'q29.row6': '{q17.6} = 1 and {q18.6} = 1',
    'q29.row7': '{q17.7} = 1 and {q18.7} = 1',
    'q29.row8': '{q17.8} = 1 and {q18.8} = 1',
    'q29.row9': '{q17.9} = 1 and {q18.9} = 1',

    q31: '{q30} = 0 or {q30} = 1 or {q30} = 2 or {q30} = 3 or {q30} = 4',
    q32: '{q30} = 0 or {q30} = 1 or {q30} = 2 or {q30} = 3 or {q30} = 4',
    q33: '{q30} = 0 or {q30} = 1 or {q30} = 2 or {q30} = 3 or {q30} = 4',

    q35: '{q34} = 0 or {q34} = 1 or {q34} = 2 or {q34} = 3 or {q34} = 4 or {q34} = 5',
    q36: '{q34} = 0 or {q34} = 1 or {q34} = 2 or {q34} = 3 or {q34} = 4 or {q34} = 5',
    q37: '({q34} = 0 or {q34} = 1 or {q34} = 2 or {q34} = 3 or {q34} = 4 or {q34} = 5) and ({q36} = 0)',
    q38: '({q34} = 0 or {q34} = 1 or {q34} = 2 or {q34} = 3 or {q34} = 4 or {q34} = 5) and ({q36} = 0)',
    q39: '({q34} = 0 or {q34} = 1 or {q34} = 2 or {q34} = 3 or {q34} = 4 or {q34} = 5) and ({q36} = 0)',
    q40: '({q34} = 0 or {q34} = 1 or {q34} = 2 or {q34} = 3 or {q34} = 4 or {q34} = 5) and ({q36} = 0)',
    q41: '{q34} = 0 or {q34} = 1 or {q34} = 2 or {q34} = 3 or {q34} = 4 or {q34} = 5',
    q42: '({q34} = 0 or {q34} = 1 or {q34} = 2 or {q34} = 3 or {q34} = 4 or {q34} = 5) and {q41} = "other"',
    q43: '({q34} = 0 or {q34} = 1 or {q34} = 2 or {q34} = 3 or {q34} = 4 or {q34} = 5) and {q41} = "other"',
    q44: '({q34} = 0 or {q34} = 1 or {q34} = 2 or {q34} = 3 or {q34} = 4 or {q34} = 5)',
    q45: '({q34} = 0 or {q34} = 1 or {q34} = 2 or {q34} = 3 or {q34} = 4 or {q34} = 5) and {q44} = "other"',
    q46: '({q34} = 0 or {q34} = 1 or {q34} = 2 or {q34} = 3 or {q34} = 4 or {q34} = 5) and {q44} = "other"',

    q73: '{q72} = 0',
    q74: '{q72} = 1 or {q72} = 2',
    q75: '{q72} = 1 or {q72} = 2 or {q72} = 3 or {q72} = 4 or {q72} = 5',

    q81: '{q13} = 100', // 隱藏
    q83: '{q82} = "other"',
    q84: '{q82} = "other"',
    q86: '{q85} = "other"',
    q87: '{q85} = "other"',

    q90: '{q89} = 1 or {q89} = 2',
    q91: '{q89} = 1 or {q89} = 2',
    q92: '{q89} = 1 or {q89} = 2',
    q93: '{q89} = 1 or {q89} = 2',
    q94: '{q89} = 1 or {q89} = 2',
    q95: '({q89} = 1 or {q89} = 2) and ({q94} = 0)',
    q96: '({q89} = 1 or {q89} = 2) and ({q94} = 1)',
    q97: '{q89} = 1 or {q89} = 2',
    q98: '{q89} = 1 or {q89} = 2',
    q99: '{q89} = 1 or {q89} = 2',
    q100: '{q89} = 1 or {q89} = 2',
    q101: '{q89} = 1 or {q89} = 2',

    q103: '{q102} = 0 or {q102} = 1',

    // 特殊矩陣
    q107: '{q106.0} = 0',
    q108: '{q106.1} = 0',
    q109: '{q106.2} = 0',
    q110: '{q106.3} = 0',
    q111: '{q106.0} = 1 or {q106.1} = 1 or {q106.2} = 1 or {q106.3} = 1',
    'q111.row0': '{q106.0} = 1',
    'q111.row1': '{q106.1} = 1',
    'q111.row2': '{q106.2} = 1',
    'q111.row3': '{q106.3} = 1',

    q127: '{q126} anyof [0, 1, 2, "other"]',
    q128: '{q126} anyof [0, 1, 2, "other"]',
    q129: '{q126} anyof [0, 1, 2, "other"]',
    q130: '{q126} anyof [0, 1, 2, "other"]',

    q131: '({q126} anyof [0, 1, 2, "other"])',
    q132: '({q126} anyof [0, 1, 2, "other"]) and ({q130.0} = 0 or {q130.0} = 1)',
    q133: '({q126} anyof [0, 1, 2, "other"]) and ({q130.1} = 0 or {q130.1} = 1)',
    q134: '({q126} anyof [0, 1, 2, "other"]) and ({q130.2} = 0 or {q130.2} = 1)',
    q135: '({q126} anyof [0, 1, 2, "other"]) and ({q130.3} = 0 or {q130.3} = 1) ',
    q136: '({q126} anyof [0, 1, 2, "other"]) and ({q130.4} = 0 or {q130.4} = 1)',
    q137: '({q131} = "other")',

    q139: '{q138} = 1',
    q140: '{q138} = 1',
  }

  // q68~q140 都要有 {q67} = 0 的條件
  // 有跳題邏輯：加上 {q67} = 0 and (原條件)
  // 沒有跳題邏輯：設為 {q67} = 0
  const visibleIfConditionsInit = (() => {
    const Q67 = '({q67} = 0)'
    const result = { ...visibleIfConditionsInitBase }
    for (let n = 68; n <= 140; n++) {
      const key = `q${n}`
      if (!(key in result)) result[key] = Q67
    }
    for (const key of Object.keys(result)) {
      const match = key.match(/^q(\d+)/)
      if (!match) continue
      const n = parseInt(match[1], 10)
      if (n < 68 || n > 140) continue
      const existing = result[key].trim()
      result[key] = existing === Q67 ? Q67 : `${Q67} and (${existing})`
    }
    return result
  })()
  // const visibleIfConditionsInit = null
  // const pageVisibleIfConditionsInit = null

  // 非必填(從 0 計算)
  // const notRequired = [117.5]
  const notRequired = null

  const mappedRateChoice = null
  // const pageBreakQuestions = ['q6', 'q11', 'q15']
  const pageBreakQuestions = null

  const triggersConditionsInit = [
    {
      type: 'complete',
      expression: `({q0} = "other")`,
    },
  ]
  // const triggersConditionsInit = null
  // const pageVisibleIfConditionsInit = null
  // 帶出: 帶入
  const questionMappings = {
    // q20: 'q21',
  }

  const convertedSurvey = useConvertSurvey({
    survey: agreeSurvey,
    pid,
    setAc,
    setTk,
    ac,
    tk,
    setMyAgreeJson,
    imagesReadingTime,
    setImagesReadingTime,
    setIsLoading,
    completedHtml,
    visibleIfConditionsInit,
    notRequired,
    mappedRateChoice,
    pageBreakQuestions,
    requiresLogin,
    triggersConditionsInit,
    questionMappings,
    bringOptionsMapRef,
    userIdRef,
    choiceIndexMapRef,
    sfdSamplerId,
    sfdPId,
  })

  // const newSurvey = new Model(convertedSurvey)

  const surveyModel = useMemo(() => {
    if (!convertedSurvey) return null
    return new Model(convertedSurvey)
  }, [convertedSurvey])

  useProgressSaving({
    userIdRef,
    surveyModel,
    convertedSurvey: myAgreeJson,
    requiresLogin,
    setIsLoading,
    pid,
    ac,
    tk,
    choiceIndexMapRef,
    choicesOrderRef,
    bringOptionsMapRef,
  })

  // 當 surveyModel 建立時，自動捲動到頂端
  useEffect(() => {
    if (surveyModel) {
      // 延遲執行以確保 DOM 已更新
      setTimeout(() => {
        // 捲動到頁面頂端
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'instant', // 平滑捲動，也可以使用 'instant' 立即跳到頂端
        })

        // 或者也可以嘗試捲動問卷容器本身
        const surveyContainer = document.querySelector('.sd-root-modern')
        if (surveyContainer) {
          surveyContainer.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
      }, 100) // 給 DOM 一點時間完成渲染
    }
  }, [surveyModel])

  // useEffect(() => {
  //   console.log('convertedSurvey', convertedSurvey)
  // }, [convertedSurvey])

  const endMessage = `<p>感謝您接受本次調查！</p>`

  function helpFunction(survey, options) {
    // console.log('survey.getValue(q42)', survey.getValue('q42'))
    // 參考 P231113152849 或 P231101165555 或 P231206105643(政大帶入選項)
  }

  const endSurveyMsg = (survey) => {
    if (survey.getValue('q0') === 'other') {
      setCompletionMessage(endMessage)
    } else {
      setCompletionMessage(
        `<div>感謝您的填答～歡迎轉發分享！<br><br>想參加更多問卷調查活動？手指點點就可以抽獎賺好康！<br>點擊下方按鈕加入 EZChoice APP<br>或複製下載連結 <a href="https://ezcapp.page.link/tAQv" target="_blank">https://ezcapp.page.link/tAQv</a><br>裡面還有更多填問卷拿購物金的活動唷～<br>各種好玩的問卷等你來玩！<br><br>想知道更多好康問卷、活動消息，請追蹤關注<br><a href="https://www.facebook.com/EasyCTRs" target="_blank">【輕鬆點點】粉絲專頁</a><br><br>加入我們的 <a href="https://lin.ee/HWETcqy" target="_blank">LINE@</a>，<br>隨時得到最新填問卷獲好禮的消息。<br><br><h4 style="text-align: center">請按「完成」前往下載 EZChoice 或填寫更多問卷</h4></div>`
      )
    }
  }

  // useEffect(() => {
  //   console.log('bringOptionsMapRef', bringOptionsMapRef)
  // }, [bringOptionsMapRef])

  useSubmitAnswers({
    survey: surveyModel,
    pid,
    ac,
    tk,
    imagesReadingTime,
    setIsLoading,
    helpFunction,
    canShowPrevButtonPages,
    choicesOrderRef,
    choiceIndexMapRef,
    endSurveyMsg,
    bringOptionsMapRef,
    requiresLogin,
    userIdRef,
    enableProgressSaving: requiresLogin.login,
  })

  return (
    <>
      {surveyModel ? (
        <Survey model={surveyModel} key={pid} />
      ) : myAgreeJson ? (
        <Survey model={agreeSurvey} />
      ) : (
        <></>
      )}
    </>
  )
}

export default Agree
